export default __webpack_public_path__ + "locales/ja-JP/Payments.json?hash=0aa25954da8a054b4118e47570a42915";